/** Curriculum for admin training mode — order mirrors real club setup */

import {
  getActivationStep,
  TRAINING_EXTENDED_LESSON_IDS,
  TRAINING_FULL_LESSON_IDS,
  TRAINING_QUICK_LESSON_IDS,
} from "../activation/activationPath";

export const TRAINING_TRACKS = {
  quick: {
    id: "quick",
    label: "Быстрый старт",
    short: "Основы: от направления до журнала",
    lessonIds: TRAINING_QUICK_LESSON_IDS,
    eta: "~8 мин",
  },
  full: {
    id: "full",
    label: "Полное обучение",
    short: "Все разделы CRM: от направления до настроек клуба",
    lessonIds: TRAINING_FULL_LESSON_IDS,
    eta: "~20 мин",
  },
};

function lessonMeta(id, index) {
  const step = getActivationStep(id);
  if (!step) return null;
  return {
    id: step.id,
    index,
    title: step.title,
    short: step.short,
    route: step.route,
    hint: step.hint,
    detail: step.short ? `${step.short}. ${step.hint}` : step.hint,
    success: step.success || "Правильно!",
    predicate: step.predicate,
    trainingOnly: Boolean(step.trainingOnly),
  };
}

export function buildTrainingLessons(trackId = "quick", opts = {}) {
  const track = TRAINING_TRACKS[trackId] || TRAINING_TRACKS.quick;
  let ids = track.lessonIds;
  if (opts.scope === "extended") {
    ids = TRAINING_EXTENDED_LESSON_IDS;
  } else if (opts.scope === "full") {
    ids = TRAINING_FULL_LESSON_IDS;
  } else if (Array.isArray(opts.lessonIds) && opts.lessonIds.length) {
    ids = opts.lessonIds;
  }
  return ids.map((id, i) => lessonMeta(id, i + 1)).filter(Boolean);
}

/** Default catalog (full track) for legacy imports */
export const TRAINING_LESSONS = buildTrainingLessons("full");

export const TRAINING_STORAGE_KEY = "baysport_admin_training";

export function loadTrainingProgress(tenantId) {
  if (!tenantId) {
    return {
      completed: [],
      skipped: [],
      offerDismissed: false,
      track: "quick",
    };
  }
  try {
    const raw = sessionStorage.getItem(`${TRAINING_STORAGE_KEY}_${tenantId}`);
    return raw
      ? { track: "quick", ...JSON.parse(raw) }
      : { completed: [], skipped: [], offerDismissed: false, track: "quick" };
  } catch {
    return { completed: [], skipped: [], offerDismissed: false, track: "quick" };
  }
}

export function saveTrainingProgress(tenantId, patch) {
  if (!tenantId) return;
  const prev = loadTrainingProgress(tenantId);
  sessionStorage.setItem(
    `${TRAINING_STORAGE_KEY}_${tenantId}`,
    JSON.stringify({ ...prev, ...patch }),
  );
}
